import React from 'react';
import { Image, ImageBackground, View } from 'react-native';
import { Button, Text } from '~/components';

import BannerImg from '~/assets/img/banners/marisa-takes-care-banner.png';
import BannerImgDesk from '~/assets/img/banners/marisa-takes-care-banner-desk.png';
import useAppNavigation from '~/hooks/useAppNavigation';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

interface BannerProps {
  showButton?: boolean;
}

const Banner: React.FC<BannerProps> = ({ showButton = true }) => {
  const { navigate } = useAppNavigation();

  const onContinue = () => {
    MarisaAppUtils.disableInsurance
      ? MarisaAppUtils.goToStoresList()
      : navigate('MarisaServicos_MarisaTakesCareContract', { step: 1 });
  };

  return (
    <>
      <ImageBackground
        source={BannerImg}
        resizeMode="cover"
        className={`w-full xl:hidden ${
          showButton ? 'h-48' : 'h-40'
        } justify-center xl:rounded-2xl xl:mt-24 flex xl:hidden`}
      >
        <View className="pl-6 w-[55%]">
          <Text className="text-light-100 text-lg font-bold">Marisa Cuida</Text>

          <Text className="text-light-100 mt-2 text-sm">
            A Marisa Cuida da sua saúde para você
          </Text>

          {showButton && (
            <Button
              className="mr-auto px-4 py-2 rounded-2xl mt-4"
              onPress={onContinue}
            >
              {MarisaAppUtils.disableInsurance
                ? 'CONTRATE EM NOSSAS LOJAS'
                : 'CONTRATE'}
            </Button>
          )}
        </View>
      </ImageBackground>

      <Image
        source={BannerImgDesk}
        resizeMode="cover"
        className={`w-[518px] h-[669px] p-6 hidden xl:flex rounded-2xl`}
      />
    </>
  );
};

export default Banner;
